import * as React from "react";

import { OpenExtendedErrorLogFromPlace } from "../ErrorLogModal/ErrorLogModalLabel";
import { ErrorLogModalLabelContainer as ErrorLogModalLabel } from "../ErrorLogModal/ErrorLogModalLabelContainer";
import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { ERROR_LOG_REQUEST_FAILED } from "../../../metricsAction";
import { ErrorLog } from "../../../../Engine/Core/ErrorManager/Utils/Models";

import QuestionIcon from "./Icons/Question.png";
import RequestFailedIcon from "./Icons/WarningTriangle.svg";
import SuccessIcon from "./Icons/Success.svg";
import WaitForAttachmentsIcon from "./Icons/WaitForAttachments.png";
import { StatusHeader } from "./CheckingStatus.styles";

interface Props {
    hasNotLoadedAttachments: boolean;
    modelChanged?: boolean;
    requestFailed: boolean;
    errorLog: ErrorLog;
    useExtendedErrorLog: boolean;
}

export function CheckingStatus(props: Props): JSX.Element {
    const track = useMetrics();
    const { modelChanged, requestFailed, hasNotLoadedAttachments } = props;

    const getRequestFailedIcon = () => {
        track(ERROR_LOG_REQUEST_FAILED);
        return RequestFailedIcon;
    };

    if (hasNotLoadedAttachments) {
        return (
            <div>
                <img src={WaitForAttachmentsIcon} />
                <br />
                <p data-tid="Text">Дождитесь загрузки файлов</p>
            </div>
        );
    } else if (modelChanged) {
        return (
            <div>
                <img src={QuestionIcon} />
                <br />
                <p data-tid="Text">Данные были изменены. Повторите проверку.</p>
            </div>
        );
    } else if (requestFailed) {
        return (
            <div>
                <div>
                    <img src={getRequestFailedIcon()} />
                </div>
                <StatusHeader>Не удалось проверить</StatusHeader>
                <p data-tid="Text">
                    Что-то сломалось, попробуйте еще раз. Если&nbsp;не&nbsp;получится, напишите в&nbsp;техподдержку
                </p>
            </div>
        );
    } else {
        return (
            <div>
                <div>
                    <img src={SuccessIcon} />
                </div>
                <StatusHeader>Отчет готов к отправке</StatusHeader>
                <p data-tid="Text">Ошибок и предупреждений нет</p>
                <div>
                    {props.useExtendedErrorLog && props.errorLog.successesTotalCount != 0 && (
                        <ErrorLogModalLabel
                            openedFrom={OpenExtendedErrorLogFromPlace.fromFullSuccessResult}
                            errorLog={props.errorLog}
                            type="link"
                        />
                    )}
                </div>
            </div>
        );
    }
}
